import { useLocation } from "react-router-dom";

/**
 * Identifies which list page a user navigated from when opening a meeting
 * workspace or meeting, so the interior breadcrumbs can root correctly.
 */
export const MEETING_BREADCRUMB_SOURCE = {
	companyMeetings: "company-meetings",
	actionItems: "action-items",
	dashboard: "dashboard",
	meetingWorkspaces: "meeting-workspaces",
} as const;

export type MeetingBreadcrumbSource = (typeof MEETING_BREADCRUMB_SOURCE)[keyof typeof MEETING_BREADCRUMB_SOURCE];

export const MEETING_BREADCRUMB_SOURCE_PARAM = "source";

export const parseMeetingBreadcrumbSource = (search: string): MeetingBreadcrumbSource => {
	const value = new URLSearchParams(search).get(MEETING_BREADCRUMB_SOURCE_PARAM);
	return value === MEETING_BREADCRUMB_SOURCE.companyMeetings ||
		value === MEETING_BREADCRUMB_SOURCE.actionItems ||
		value === MEETING_BREADCRUMB_SOURCE.dashboard
		? value
		: MEETING_BREADCRUMB_SOURCE.meetingWorkspaces;
};

export const useMeetingBreadcrumbSource = (): MeetingBreadcrumbSource =>
	parseMeetingBreadcrumbSource(useLocation().search);

export const appendMeetingBreadcrumbSource = (href: string, source: MeetingBreadcrumbSource): string => {
	if (source === MEETING_BREADCRUMB_SOURCE.meetingWorkspaces) return href;
	return `${href}${href.includes("?") ? "&" : "?"}${MEETING_BREADCRUMB_SOURCE_PARAM}=${source}`;
};
